import { spaceQueries } from "@circle-react/lib/queries/spaces";
import type { SpaceResource } from "@circle-react/types/Space";
import { useMemo } from "react";
import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

interface UseSpaceResourceOptions {
  queryOptions?: Omit<
    ReturnType<typeof spaceQueries.resourceDetail>,
    "queryKey" | "queryFn"
  >;
  spaceId?: number;
}

export type UseSpaceResourceReturn = Pick<
  UseQueryResult<SpaceResource>,
  "data" | "isInitialLoading" | "isPending" | "refetch"
> & {
  space: SpaceResource | undefined;
};

export const useSpaceResource = ({
  spaceId,
  queryOptions = {},
}: UseSpaceResourceOptions): UseSpaceResourceReturn => {
  const query = useQuery({
    ...spaceQueries.resourceDetail(spaceId),
    ...queryOptions,
  });

  return useMemo(
    () => ({
      data: query.data,
      isInitialLoading: query.isInitialLoading,
      isPending: query.isPending,
      refetch: query.refetch,
      space: query.data,
    }),
    [query.data, query.isInitialLoading, query.isPending, query.refetch],
  );
};
